import { motion } from "framer-motion";

const ScrollNav = ({ color = "text-redlight" }) => {
  const scroll = (direction) => {
    const viewport = window.innerHeight * 0.9; // scroll almost one screen

    if (direction === "down") {
      window.scrollBy({
        top: viewport,
        behavior: "smooth",
      });
    }

    if (direction === "up") {
      window.scrollBy({
        top: -viewport,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="fixed right-6 bottom-16 md:bottom-20 z-[999] flex flex-col items-center">
      {/* UP */}
      <motion.div
        onClick={() => scroll("up")}
        animate={{ y: [-6, 0, -6] }}
        transition={{ duration: 1.4, repeat: Infinity }}
        className="text-redlight text-lg font-bold cursor-pointer 
  flex items-center justify-center 
  w-8 h-8 rounded-full 
  hover:bg-darkbg transition"
      >
        ↑
      </motion.div>

      {/* DOWN */}
      <motion.div
        onClick={() => scroll("down")}
        animate={{ y: [0, 6, 0] }}
        transition={{ duration: 1.4, repeat: Infinity }}
        className={`text-redlight text-lg font-bold cursor-pointer 
  flex items-center justify-center 
  w-8 h-8 rounded-full 
  hover:bg-darkbg transition`}
      >
        ↓
      </motion.div>
    </div>
  );
};

export default ScrollNav;
